import React from "react";
import { FormActions } from "../app";
import {
  InvoiceDateFields,
  InvoiceEntityFields,
  InvoiceItemsEditor,
  InvoiceNotesField,
} from "./InvoiceFormSections";

export function InvoiceCreateForm({
  formData,
  setFormData,
  clients,
  projects,
  t,
  onSubmit,
  onCancel,
  onAddItem,
  onUpdateItem,
  onRemoveItem,
  onTaxRateChange,
}) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <InvoiceEntityFields
        formData={formData}
        setFormData={setFormData}
        clients={clients}
        projects={projects}
        t={t}
      />

      <InvoiceDateFields formData={formData} setFormData={setFormData} t={t} />

      <InvoiceItemsEditor
        formData={formData}
        t={t}
        onAddItem={onAddItem}
        onUpdateItem={onUpdateItem}
        onRemoveItem={onRemoveItem}
        onTaxRateChange={onTaxRateChange}
      />

      <InvoiceNotesField formData={formData} setFormData={setFormData} t={t} />

      <FormActions
        cancelLabel={t("cancel")}
        submitLabel={t("save")}
        onCancel={onCancel}
        submitTestId="save-invoice-btn"
      />
    </form>
  );
}

export default InvoiceCreateForm;
